'use client';

import React from 'react';
import {
  mediaPreviewSlotClassName,
  mediaPreviewSlotStyle,
  type SpreadsheetMediaLike,
} from '@/shared/media-preview-layout';

export type MediaPreviewSlotProps = {
  children: React.ReactNode;
  /** Flex column parent: fill available height (drawers, evidence locker overlay). */
  fillContainer?: boolean;
  mediaItem?: SpreadsheetMediaLike | null;
  viewAsCsvLike?: boolean;
  className?: string;
  style?: React.CSSProperties;
  minHeight?: number;
  isContinuousMedia?: boolean;
};

export const MediaPreviewSlot = React.forwardRef<HTMLDivElement, MediaPreviewSlotProps>(
  function MediaPreviewSlot(
    {
      children,
      fillContainer,
      mediaItem,
      viewAsCsvLike,
      className = '',
      style,
      minHeight,
      isContinuousMedia,
    },
    ref,
  ) {
    const slotClassName = mediaPreviewSlotClassName(fillContainer, mediaItem, {
      viewAsCsvLike,
      extraClassName: className,
    });
    const slotStyle = {
      ...mediaPreviewSlotStyle(fillContainer, mediaItem, {
        viewAsCsvLike,
        minHeight,
        isContinuousMedia,
      }),
      ...style,
    };

    return (
      <div ref={ref} className={slotClassName} style={slotStyle}>
        {children}
      </div>
    );
  },
);
